import request from '@/libs/request'

// 平台用户列表
export function vipList (data) {
  return request({
    url: `vip/list`,
    method: 'get',
    params: data
  })
}

export function addVip (data) {
  return request({
    url: `vip/info`,
    method: 'post',
    data
  })
}

export function vipInfo (id) {
  return request({
    url: `vip/list/${id}`,
    method: 'get'
  })
}
export function delCate (id) {
  return request({
    url: `vip/list/${id}`,
    method: 'delete'
  })
}

// 启用禁用用户
export function changeStatus (id) {
  return request({
    url: `vip/changeStatus/${id}`,
    method: 'post'
  })
}
